import { render, staticRenderFns } from "./AlertTrendWidget.vue?vue&type=template&id=2aeae622&"
import script from "./AlertTrendWidget.vue?vue&type=script&lang=js&"
export * from "./AlertTrendWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports